import { WAIT_FOR_ACTION, ERROR_ACTION } from "redux-wait-for-action";
import { appendGaEventToAction } from "./googleAnalytics";

export const RECEIVE_APPCONFIG = "RECEIVE_APPCONFIG";
export const RECEIVE_APPCONFIG_SUCCESS = "RECEIVE_APPCONFIG_SUCCESS";
export const RECEIVE_APPCONFIG_FAIL = "RECEIVE_APPCONFIG_FAIL";
export const UPDATE_PROSPECT = "UPDATE_PROSPECT";
export const RESET_PROSPECT = "RESET_PROSPECT";
export const SET_CONFIG = "SET_CONFIG";
export const SET_PROSPECT = "SET_PROSPECT";
export const UPDATE_PROSPECT_ID = "UPDATE_PROSPECT_ID";
export const UPDATE_VALID_RO_CODE = "UPDATE_VALID_RO_CODE";
export const UPDATE_VIEW_ID = "UPDATE_VIEW_ID";
export const REMOVE_PROSPECT_ID = "REMOVE_PROSPECT_ID";
export const SAVE_SIGNATORY_MODEL = "SAVE_SIGNATORY_MODEL";
export const SAVE_ORGANIZATION_INFO_MODEL = "SAVE_ORGANIZATION_INFO_MODEL";
export const SET_ACCESS_TOKEN = "SET_ACCESS_TOKEN";
export const SET_DEVICE_ID = "SET_DEVICE_ID";
export const RESET_APPLICANT_INFO = "RESET_APPLICANT_INFO";
export const LOAD_META_DATA = "LOAD_META_DATA";
export const SET_PROSPECT_LEAD = "SET_PROSPECT_LEAD";
export const SET_EXPIRED = "SET_EXPIRED";
export const SET_RO_CODE = "SET_RO_CODE";
export const INITIAL_CHECK = "INITIAL_CHECK";
export const KYC_INITIAL_EDIT_CHECK = "KYC_INITIAL_EDIT_CHECK";
export const UPDATE_COMEBACK_STATUS = "UPDATE_COMEBACK_STATUS";
export const GET_POSTLOGIN_TOKEN_REQUEST = "GET_POSTLOGIN_TOKEN_REQUEST";
export const GET_POSTLOGIN_TOKEN_SUCCESS = "GET_POSTLOGIN_TOKEN_SUCCESS";
export const GET_POSTLOGIN_TOKEN_FAIL = "GET_POSTLOGIN_TOKEN_FAIL";

export const loadMetaData = (meta = {}) => ({
  type: LOAD_META_DATA,
  payload: meta.freeField5 || ""
});

export const receiveAppConfig = payload => ({
  type: RECEIVE_APPCONFIG,
  payload
});

export const receiveAppConfigSuccess = payload => {
  return { type: RECEIVE_APPCONFIG_SUCCESS, payload };
};

export const receiveAppConfigFail = payload => {
  return { type: RECEIVE_APPCONFIG_FAIL, payload };
};

export const updateProspect = (payload, gaEvent = null) => {
  const action = { type: UPDATE_PROSPECT, payload };

  return appendGaEventToAction(action, gaEvent);
};

export const setConfig = payload => {
  return { type: SET_CONFIG, payload };
};

export const setInitialCheck = payload => {
  return { type: INITIAL_CHECK, payload };
};

export const setProspect = payload => {
  return { type: SET_PROSPECT, payload };
};

export const resetProspect = () => {
  return { type: RESET_PROSPECT };
};

export const updateProspectId = payload => {
  return { type: UPDATE_PROSPECT_ID, payload };
};

export const updateValidRoCode = payload => {
  return { type: UPDATE_VALID_RO_CODE, payload };
};

export const removeProspectId = () => {
  return { type: REMOVE_PROSPECT_ID };
};

export const updateViewId = (viewId, isSendToApi) => {
  return { type: UPDATE_VIEW_ID, payload: { viewId, isSendToApi } };
};

export const saveSignatoryModel = payload => {
  return { type: SAVE_SIGNATORY_MODEL, payload };
};

export const saveOrganizationInfoModel = payload => {
  return { type: SAVE_ORGANIZATION_INFO_MODEL, payload };
};

export const setAccessToken = (accessToken, refreshToken = "") => ({
  type: SET_ACCESS_TOKEN,
  payload: { accessToken, refreshToken }
});

export const setDeviceId = deviceId => ({ type: SET_DEVICE_ID, payload: deviceId });

export const resetApplicantInfo = () => ({ type: RESET_APPLICANT_INFO });

export const setProspectLead = payload => {
  return { type: SET_PROSPECT_LEAD, payload };
};

export const setRoCode = payload => {
  return { type: SET_RO_CODE, payload };
};

export const setExpired = expired => ({ type: SET_EXPIRED, payload: expired });

export const setKycInitialEditCheck = payload => {
  return { type: KYC_INITIAL_EDIT_CHECK, payload };
};

export const updateComeBackStatus = payload => ({ type: UPDATE_COMEBACK_STATUS, payload });

export const getPostLoginTokenPromisify = prospectId => ({
  type: GET_POSTLOGIN_TOKEN_REQUEST,
  [WAIT_FOR_ACTION]: GET_POSTLOGIN_TOKEN_SUCCESS,
  [ERROR_ACTION]: GET_POSTLOGIN_TOKEN_FAIL,
  payload: {
    prospectId
  }
});

export const getProspectInfoSuccess = prospect => {
  return { type: GET_POSTLOGIN_TOKEN_SUCCESS, payload: { prospect } };
};

export const getProspectInfoFail = error => {
  return { type: GET_POSTLOGIN_TOKEN_FAIL, error };
};
